module.exports = __webpack_public_path__ + "img/intel_write.1bb68aeb.svg";